import type { Ari } from '@atlassian/ari';
import {
	ConfluenceBlogpostAri,
	ConfluencePageAri,
	ConfluenceWhiteboardAri,
} from '@atlassian/ari/confluence';

export const getConfluenceContentAri = (
	siteId: string,
	contentId: string,
	contentType: string,
): Ari | undefined => {
	try {
		switch (contentType) {
			case 'page':
				return ConfluencePageAri.create({
					siteId,
					pageId: contentId,
				});
			case 'blogpost':
				return ConfluenceBlogpostAri.create({
					siteId,
					blogpostId: contentId,
				});
			case 'whiteboard':
				return ConfluenceWhiteboardAri.create({
					siteId,
					whiteboardId: contentId,
				});
		}
	} catch {
		return undefined;
	}
	return undefined;
};
